import { Link } from "react-router-dom";
import { Search, Shield, TrendingDown } from "lucide-react";

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b">
      <div className="container mx-auto flex items-center justify-between h-16 px-6">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-hero flex items-center justify-center">
            <Search className="w-4 h-4 text-primary-foreground" />
          </div>
          <span className="font-display text-xl font-bold text-foreground tracking-tight">bnbxo</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Home</Link>
          <Link to="/search" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Search Tool</Link>
          <Link to="/listings" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Listings</Link>
          <Link to="/dashboard" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Dashboard</Link>
          <Link to="/host" className="text-sm text-muted-foreground hover:text-foreground transition-colors">For Hosts</Link>
          <Link to="/contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Contact</Link>
          <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Blog</Link>
        </nav>
        <Link
          to="/search"
          className="bg-gradient-hero text-primary-foreground px-5 py-2 rounded-lg text-sm font-semibold hover:opacity-90 transition-opacity shadow-savings"
        >
          Try it Free
        </Link>
      </div>
    </header>
  );
};

export default Header;
